export const urlRegex = /^(ftp|http|https):\/\/[^ "]+$/;

export const integerRegex = /^\d*$/;

export const keyRegex = /^[a-z0-9_]+$/;

export const codeBlockRegex = /```[\s\S]*?```/g;
